import React from 'react'
import { useTranslation } from 'react-i18next';
import {
  Button,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import LandingCard from '../../sections/@dashboard/landing/LandingCard';
import Iconify from '../../components/Iconify';

import Page from '../../components/Page';
import { LadingService } from '../../Services/landing.service';
import { useLoadingContext } from '../../context/loadingContext';

const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [landings, setLanding] = React.useState([]);
  const { handleStartLoading, handleStopLoading } = useLoadingContext()

  React.useEffect(() => {
    GetPromotion().finally(handleStopLoading);
  }, []);

  const GetPromotion = async () => {
    handleStartLoading();
    const landingDate = await LadingService.GetLanding();
    setLanding(landingDate);
  };

  const handleEnableLanding = React.useCallback(
    (id) => {
      handleStartLoading()
      LadingService.EnableLanding(id)
        .then(() => {
          console.log({ landings });
          const newData = landings.map((item) => {
            if (item._id === id) item.status = 'Enable';
            return item;
          });
          setLanding(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading)
    },
    [landings]
  );

  const handleDisableLanding = React.useCallback(
    (id) => {
      handleStartLoading()
      LadingService.DisableLanding(id)
        .then(() => {
          const newData = landings.map((item) => {
            if (item._id === id) item.status = 'Disable';
            return item;
          });
          setLanding(newData);
          enqueueSnackbar('Thành công', { variant: 'success' });
        })
        .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
        .finally(handleStopLoading)
    },
    [landings]
  );

  const handleEditLanding = React.useCallback((_id) => navigate(`/landing/${_id}`), []);
  return (
    <Page title={'Promotion'}>
      <Container maxWidth="lg">

        {landings.map((landing) => (
          <LandingCard
            key={landing._id}
            landing={landing}
            onEdit={handleEditLanding}
            onDisable={handleDisableLanding}
            onEnable={handleEnableLanding}
          />
        ))}
      </Container>
    </Page>
  );
}

export default LandingPage